class ActionsDrawer {
    constructor() {
      this.drawer = document.getElementById('actions-drawer');
      if (!this.drawer) return;
  
      this.titleEl = this.drawer.querySelector('#actions-drawer-title');
      this.bodyEl = this.drawer.querySelector('#actions-drawer-body');
      this.footerEl = this.drawer.querySelector('#actions-drawer-footer');
      this.closeButton = this.drawer.querySelector('.actions-drawer__close');
      this.overlay = this.drawer.querySelector('.actions-drawer__overlay');
  
      this.wishlistKey = 'shopify-wishlist-items';
      this.compareKey = 'shopify-compare-items';
  
      this.wishlist = JSON.parse(localStorage.getItem(this.wishlistKey) || '[]');
      this.compareList = JSON.parse(localStorage.getItem(this.compareKey) || '[]');
  
      this.highlightedCard = null;
  
      this.initEventListeners();
      this.updateAllActionButtons();
    }
  
    initEventListeners() {
      this.closeButton.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());
  
      document.body.addEventListener('click', (e) => {
        const target = e.target;
        const actionItem = target.closest('.product-actions-block__item');
        
        if (actionItem) {
          const productCard = actionItem.closest('.card-wrapper');
          const actionsBlock = actionItem.closest('[data-product-handle]');
          if (!actionsBlock) return;
          
          const productHandle = actionsBlock.dataset.productHandle;
  
          if (actionItem.classList.contains('product-actions-block__wishlist')) {
            this.open('wishlist', productCard);
            if (productHandle && !this.wishlist.includes(productHandle)) {
              this.wishlist.push(productHandle);
              this.saveLists();
            }
            this.renderWishlistContent();
          }
  
          if (actionItem.classList.contains('product-actions-block__compare')) {
            e.preventDefault();
            const isInCompare = this.compareList.includes(productHandle);
            if (isInCompare) {
              window.location.href = '/pages/compare';
            } else {
              this.open('compare', productCard);
              if (productHandle && !isInCompare) {
                this.compareList.push(productHandle);
                this.saveLists();
              }
              this.renderCompareContent();
            }
          }
  
          if (actionItem.classList.contains('product-actions-block__share')) {
            this.open('share', productCard, productHandle);
          }
        }
        
        const removeButton = target.closest('[data-remove-handle]');
        if (removeButton && target.closest('.actions-drawer')) {
          const handle = removeButton.dataset.removeHandle;
          const type = removeButton.dataset.removeType;
          
          if (type === 'wishlist') {
            this.wishlist = this.wishlist.filter(item => item !== handle);
            this.saveLists();
            this.renderWishlistContent();
          } else if (type === 'compare') {
            this.compareList = this.compareList.filter(item => item !== handle);
            this.saveLists();
            this.renderCompareContent();
          }
        }
      });
      
      window.addEventListener('storage', () => this.updateAllActionButtons());
    }
    
    open(type, cardElement = null, contextHandle = null) {
      this.currentType = type;
      this.contextHandle = contextHandle;
      
      document.body.classList.add('overflow-hidden');
      this.drawer.setAttribute('aria-hidden', 'false');
      
      this.overlay.classList.add('actions-drawer-overlay--spotlight');
  
      if (cardElement) {
        this.highlightedCard = cardElement;
        this.highlightedCard.classList.add('product-card-highlighted');
      }
      
      if (type === 'wishlist') this.renderWishlistContent();
      if (type === 'compare') this.renderCompareContent();
      if (type === 'share') this.renderShareContent();
    }
  
    close() {
      document.body.classList.remove('overflow-hidden');
      this.drawer.setAttribute('aria-hidden', 'true');
      
      this.overlay.classList.remove('actions-drawer-overlay--spotlight');
      
      if (this.highlightedCard) {
        this.highlightedCard.classList.remove('product-card-highlighted');
        this.highlightedCard = null;
      }
    }
  
    saveLists() {
      localStorage.setItem(this.wishlistKey, JSON.stringify(this.wishlist));
      localStorage.setItem(this.compareKey, JSON.stringify(this.compareList));
      this.updateAllActionButtons();
      window.dispatchEvent(new Event('storage'));
    }
  
    updateAllActionButtons() {
      document.querySelectorAll('[data-product-handle]').forEach(block => {
        const handle = block.dataset.productHandle;
        const compareButton = block.querySelector('.product-actions-block__compare');
        const wishlistButton = block.querySelector('.product-actions-block__wishlist');
        if (compareButton) {
          compareButton.classList.toggle('in-compare', this.compareList.includes(handle));
        }
        if (wishlistButton) {
          wishlistButton.classList.toggle('in-wishlist', this.wishlist.includes(handle));
        }
      });
    }
  
    async renderListContent(type, list, title) {
      this.titleEl.textContent = title;
      this.bodyEl.innerHTML = '<div class="drawer-loading">Loading...</div>';
      if (list.length === 0) {
        this.bodyEl.innerHTML = `<p class="drawer-empty-message">Your list is empty.</p>`;
        return;
      }
      try {
          const productPromises = list.map(handle => fetch(`/products/${handle}.js`).then(res => res.json()));
          const products = await Promise.all(productPromises);
          let itemsHtml = '<ul class="drawer-list">';
          products.forEach(product => {
              const price = new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(product.price / 100);
              itemsHtml += `
              <li class="drawer-list-item">
                  <a href="${product.url}" class="drawer-item-link">
                      <img src="${product.featured_image}?width=100" class="drawer-item-image" alt="${product.title}" loading="lazy"/>
                      <div class="drawer-item-details">
                          <span class="drawer-item-title">${product.title}</span>
                          <span class="drawer-item-price">${price}</span>
                      </div>
                  </a>
                  <button data-remove-handle="${product.handle}" data-remove-type="${type}" class="drawer-item-remove">&times;</button>
              </li>
              `;
          });
          itemsHtml += '</ul>';
          this.bodyEl.innerHTML = itemsHtml;
      } catch (error) {
          console.error(`Error rendering ${type} drawer:`, error);
          this.bodyEl.innerHTML = `<p class="drawer-empty-message">Error loading items.</p>`;
      }
    }
  
    renderWishlistContent() {
      this.renderListContent('wishlist', this.wishlist, 'My Wishlist');
      this.footerEl.innerHTML = `<a href="/pages/wishlist" class="button button--primary button--full-width">View Full Wishlist</a>`;
    }
  
    renderCompareContent() {
      this.renderListContent('compare', this.compareList, 'Compare Products');
      const disabled = this.compareList.length < 2 ? 'disabled' : '';
      this.footerEl.innerHTML = `<a href="/pages/compare" class="button button--primary button--full-width ${disabled}">Compare Now (${this.compareList.length})</a>`;
    }
  
    renderShareContent() {
      this.titleEl.textContent = 'Share This Product';
      this.footerEl.innerHTML = '';
      const productUrl = this.contextHandle ? (window.location.origin + `/products/${this.contextHandle}`) : window.location.href;
      const productTitle = document.querySelector('.product__title')?.textContent.trim() || 'Check out this product!';
      
      const shareIcons = {
          facebook: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 2.04C6.5 2.04 2 6.53 2 12.06c0 5.52 4.5 10.02 10 10.02s10-4.5 10-10.02C22 6.53 17.5 2.04 12 2.04zM16.5 12.06h-2.1v6h-3v-6h-1.5v-2.55h1.5v-1.8c0-1.29.77-3.25 3.25-3.25h2.15v2.55h-1.27c-.38 0-.68.3-.68.72v1.78h1.95L16.5 12.06z"/></svg>',
          twitter: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M22.46 6c-.77.35-1.6.58-2.46.67.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.22-1.95-.55v.05c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.94.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/></svg>',
          pinterest: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12.017 2c-5.523 0-10 4.477-10 10 0 4.237 2.636 7.855 6.356 9.312-.088-.791-.167-2.005.035-2.868.182-.78 1.172-4.97 1.172-4.97s-.299-.6-.299-1.486c0-1.39.806-2.428 1.81-2.428.852 0 1.264.64 1.264 1.408 0 .858-.545 2.14-.828 3.33-.236.995.5 1.807 1.48 1.807 1.778 0 3.144-1.874 3.144-4.58 0-2.393-1.72-4.068-4.177-4.068-2.845 0-4.515 2.135-4.515 4.34 0 .859.331 1.781.745 2.281a.3.3 0 0 1 .069.288l-.278 1.133c-.044.183-.145.223-.335.134-1.249-.581-2.03-2.407-2.03-3.874 0-3.154 2.292-6.052 6.608-6.052 3.469 0 6.165 2.473 6.165 5.776 0 3.472-2.175 6.22-5.19 6.22-1.013 0-1.965-.525-2.291-1.148l-.623 2.378c-.226.869-.835 1.958-1.244 2.621.937.29 1.931.446 2.962.446 5.523 0 10-4.477 10-10S17.54 2 12.017 2z"/></svg>',
          whatsapp: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zM12.04 20.12c-1.48 0-2.93-.4-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31c-.82-1.28-1.25-2.78-1.25-4.32 0-4.54 3.69-8.23 8.23-8.23 4.54 0 8.23 3.69 8.23 8.23 0 4.54-3.69 8.23-8.23 8.23zm4.52-6.14c-.25-.12-1.47-.72-1.7-.82s-.39-.12-.56.12c-.17.25-.64.82-.79.98-.15.17-.29.19-.54.06s-1.06-.39-2-1.23c-.74-.66-1.23-1.48-1.38-1.73s-.02-.38.11-.51c.11-.11.25-.29.37-.43.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.42h-.5c-.17 0-.43.06-.66.31s-.87.85-.87 2.07c0 1.22.89 2.4 1.01 2.56.12.17 1.76 2.68 4.27 3.77 2.51 1.09 2.51.73 2.96.71.45-.02 1.47-.6 1.68-1.18.21-.58.21-1.09.15-1.18-.07-.1-.25-.16-.5-.28z"/></svg>',
          linkedin: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4s1.39.63 1.39 1.4v4.93h2.8zM6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69.93 1.68 1.68 0 0 0 0 .76c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/></svg>',
          email: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>'
      };
      let shareListHTML = '<ul class="drawer-share-list">';
      shareListHTML += `<li><a href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productUrl)}" target="_blank" rel="noopener">${shareIcons.facebook}<span>Facebook</span></a></li>`;
      shareListHTML += `<li><a href="https://twitter.com/intent/tweet?url=${encodeURIComponent(productUrl)}&text=${encodeURIComponent(productTitle)}" target="_blank" rel="noopener">${shareIcons.twitter}<span>Twitter</span></a></li>`;
      shareListHTML += `<li><a href="https://pinterest.com/pin/create/button/?url=${encodeURIComponent(productUrl)}&description=${encodeURIComponent(productTitle)}" target="_blank" rel="noopener">${shareIcons.pinterest}<span>Pinterest</span></a></li>`;
      shareListHTML += `<li><a href="https://api.whatsapp.com/send?text=${encodeURIComponent(productTitle + ' ' + productUrl)}" target="_blank" rel="noopener">${shareIcons.whatsapp}<span>WhatsApp</span></a></li>`;
      shareListHTML += `<li><a href="https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(productUrl)}&title=${encodeURIComponent(productTitle)}" target="_blank" rel="noopener">${shareIcons.linkedin}<span>LinkedIn</span></a></li>`;
      shareListHTML += `<li><a href="mailto:?subject=${encodeURIComponent(productTitle)}&body=${encodeURIComponent('Check this out: ' + productUrl)}">${shareIcons.email}<span>Email</span></a></li>`;
      shareListHTML += '</ul>';
      this.bodyEl.innerHTML = `<div class="share-fallback"><p>Share this product via</p>${shareListHTML}<div class="share-fallback__copy-link"><input type="text" value="${productUrl}" readonly class="share-fallback__url"><button type="button" class="share-fallback__copy-button">Copy Link</button></div></div>`;
      this.bodyEl.querySelector('.share-fallback__copy-button').addEventListener('click', (e) => {
        const button = e.currentTarget;
        const urlInput = this.bodyEl.querySelector('.share-fallback__url');
        navigator.clipboard.writeText(urlInput.value).then(() => {
          button.textContent = 'Copied!';
          setTimeout(() => { button.textContent = 'Copy Link'; }, 2000);
        }).catch(err => {
          console.error('Failed to copy: ', err);
          button.textContent = 'Error';
        });
      });
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    new ActionsDrawer();
  });